import React from "react";
import styles from "./styles.module.scss";
import HowTheBehaviourWorks from "../HowTheBehaviourWorks";
import SUDayView from "../SUDayView";

const BehaviourDaytimeDayView = ({
  movementV3Data,
  howItWorks,
  insights,
  showLearnMore,
  setShowLearnMore,
}) => {
  const oneDayOfData = movementV3Data?.[0];

  // Check if there is no data
  const noData = oneDayOfData?.durationMinutes?.dayTime >= 0 ? false : true;

  return (
    <>
      {showLearnMore && (
        <div className={styles.container}>
          <HowTheBehaviourWorks
            behaviour="Day-time"
            questionsAndAnswers={howItWorks}
            hide={() => setShowLearnMore(false)}
          />
        </div>
      )}
      {!showLearnMore && (
        <SUDayView
          noData={noData}
          insightsContext={
            "Day-time activity is the time spent moving this day between 6am - 10pm."
          }
          insights={insights}
        />
      )}
    </>
  );
};

export default BehaviourDaytimeDayView;
